import React, { Component, Fragment } from "react";
import { isNil } from "ramda";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Popover from "@mui/material/Popover";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";

const Triangle = styled("div")`
  width: 0;
  height: 0;
  border-bottom: 8px solid rgba(0, 0, 0, 0.54);
  border-left: 8px solid transparent;
  position: absolute;
  bottom: 6px;
  right: 6px;
`;

const anchorOrigin = { vertical: "bottom", horizontal: "left" };

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  "&.MuiToggleButton-root": {
    border: "none",
    padding: theme.spacing(1.5),
    borderRadius: 0,
    height: "auto",
    color: "rgba(0, 0, 0, 0.54)"
  },
  "&:focus-visible": {
    // "--dsb-outline-color": "green",
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

class IconGallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      current: this.findActiveChild()
    };
  }

  componentDidMount() {
    this.handleOnClick(this.findActiveChild());
  }

  findActiveChild = () => this.props.children.find(child => child.props.value === this.props.value);

  handleOnOpen = event => {
    event.preventDefault();
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleOnClose = () => this.setState({ anchorEl: null });

  handleOnClick = current => this.setState({ current, anchorEl: null });

  render() {
    const { current, anchorEl } = this.state;
    const { label, children, value, onChange, active, defaultIcon } = this.props;

    return (
      <>
        <Tooltip title={label}>
          <StyledToggleButton value="" selected={active} onClick={this.handleOnOpen}>
            {isNil(current) ? defaultIcon : current}
            <Triangle />
          </StyledToggleButton>
        </Tooltip>
        <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={this.handleOnClose} anchorOrigin={anchorOrigin}>
          <ToggleButtonGroup value={value} onChange={(event, value) => onChange(value)} exclusive>
            {children.map((child, n) => (
              <Tooltip key={n} title={child.props.label}>
                <StyledToggleButton
                  value={child.props.value}
                  selected={value === child.props.value}
                  onClick={event => this.handleOnClick(child)}
                >
                  {child}
                </StyledToggleButton>
              </Tooltip>
            ))}
          </ToggleButtonGroup>
        </Popover>
      </>
    );
  }
}

IconGallery.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  active: PropTypes.bool,
  defaultIcon: PropTypes.element
};

IconGallery.defaultProps = {
  label: ""
};

export default IconGallery;
